<template>
  <div class="upsert-employee">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Nav-->
            <div class="wizard-nav" style="background-color: #eef0f8">
              <div class="wizard-steps">
                <div
                  class="wizard-step"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-wrapper">
                    <div class="wizard-label">
                      <div class="wizard-title">Thông tin chung</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--begin: Wizard Body-->
            <!-- Thông tin chung -->
            <div
              class="general-info"
              data-wizard-type="step-content"
              data-wizard-state="current"
            >
              <GeneralInfo
                :generalInfo="generalInfo"
                @onSelectedStore="onSelectedStore"
                @onInputChange="onInputChange"
              />
            </div>
          </div>
        </b-card>
      </template>
      <template v-slot:foot>
        <b-button
          style="fontweight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="onSubmit"
          >Lưu</b-button
        >
        <router-link to="/employees" tag="button">
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            >Hủy</b-button
          >
        </router-link>
      </template>
    </KTCodePreview>
  </div>
</template>
<style lang="css" scoped>
.tabs /deep/ .nav-item a {
  font-size: 1rem;
  font-weight: 600;
}
.upsert-employee /deep/ .card-body {
  padding: 0;
}
.upsert-employee .general-info,
.personal-record {
  padding: 20px;
}
</style>
<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import GeneralInfo from '@/view/components/employee/GeneralInfo.vue';
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';

import KTWizard from '@/assets/js/components/wizard';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { checkPermission } from '@/utils/permission';
import { mapGetters } from 'vuex';
import KTUtil from '@/assets/js/components/util';
import apiCommonMixin from '@/view/mixins/api-common.mixins';

export default {
  mixins: [validationMixin, apiCommonMixin],
  data() {
    return {
      generalInfo: {
        id: '',
        fullName: '',
        phoneNo: '',
        email: '',
        position: {
          selected: null,
          options: [],
        },
        department: {
          selected: null,
          options: [],
        },
        searchStore: '',
        filteredOptions: [],
        code: '',
        active: {
          selected: 1,
          options: [
            { value: null, text: 'Hãy chọn trạng thái' },
            { value: 1, text: 'Hoạt động' },
            { value: 0, text: 'Không hoạt động' },
          ],
        },
      },
    };
  },
  components: {
    GeneralInfo,
    KTCodePreview,
  },
  computed: {
    ...mapGetters(['listPermission']),
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhân sự', route: '/employees' },
      { title: 'Danh sách nhân sự', route: '/employees' },
      { title: 'Cập nhật nhân sự' },
    ]);
    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: 1,
      clickableSteps: true,
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });

    this.id = this.$route.query.id;
    this.getEmployeeById();
    this.setJobTitleOptions();
    this.fetchStore();
    this.setDepartmentOptions();
  },
  methods: {
    checkPermission,
    createEmployee: async function () {
      const data = {
        fullName: this.generalInfo.fullName,
        code: this.generalInfo.code,
        jobTitleId: this.generalInfo.position.selected,
        departmentId: this.generalInfo.department.selected,
        email: this.generalInfo.email,
        store: this.generalInfo.selectedStore,
        active: this.generalInfo.active.selected,
        phoneNo: this.generalInfo.phoneNo,
        listStore: this.formatEmployeeStores(this.generalInfo.listStore),
      };

      ApiService.post('v1/employees/', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 200) {
            makeToastSuccess(message);
            this.$router.push({
              name: 'list-employee',
            });
          } else {
            makeToastFaile(message);
          }
        })
        .catch((err) => {
          const message = err.response.data.message;
          makeToastFaile(message);
        });
    },
    onContext(ctx) {
      this.generalInfo.formatted = ctx.selectedFormatted;
      this.generalInfo.selected = ctx.selectedYMD;
    },
    fetchStore: async function () {
      this.generalInfo.options = [];
      ApiService.get('v1/stores/all').then((response) => {
        const stores = response.data.data;
        this.generalInfo.listStores = stores;
        this.generalInfo.options = this.generalInfo.filteredOptions = [
          ...stores,
        ];
      });
    },
    onChangeListStore() {
      this.generalInfo.options = [];
      this.generalInfo.listStore.map((element) => {
        this.generalInfo.options.push(element);
      });
      this.generalInfo.filteredOptions = [{ data: this.generalInfo.options }];
    },
    onSubmit() {
      if (this.id) {
        return this.updateEmployee();
      }
      return this.createEmployee();
    },
    reset() {
      this.$refs.form.reset();
    },
    updateEmployee: async function () {
      const data = {
        id: this.generalInfo.id,
        code: this.generalInfo.code,
        fullName: this.generalInfo.fullName.trim(),
        jobTitleId: this.generalInfo.position.selected,
        departmentId: this.generalInfo.department.selected,
        email: this.generalInfo.email ? this.generalInfo.email.trim() : '',
        store: this.generalInfo.selectedStore,
        active: this.generalInfo.active.selected,
        phoneNo: this.generalInfo.phoneNo,
        listStore: this.formatEmployeeStores(this.generalInfo.listStore),
      };

      ApiService.put('v1/employees/', data).then((data) => {
        const { status, message } = data.data;
        if (status === 200) {
          makeToastSuccess(message);
          this.$router.push({
            name: 'list-employee',
          });
        } else {
          makeToastFaile(message);
        }
      });
    },
    getEmployeeById: async function () {
      if (!this.id) return;
      ApiService.query('v1/employees' + '/' + this.id).then((response) => {
        const dataRes = response.data.data;
        this.generalInfo.id = dataRes.id;
        this.generalInfo.fullName = dataRes.fullName;
        this.generalInfo.position.selected = dataRes.jobTitleId;
        this.generalInfo.email = dataRes.email;
        this.generalInfo.selectedStore = dataRes.storeId;
        this.generalInfo.employeeStoreId = dataRes.employeeStoreId;
        this.generalInfo.employeeStoreName = dataRes.employeeStoreName;
        this.generalInfo.active.selected = dataRes.isActive === true ? 1 : 0;
        this.generalInfo.phoneNo = dataRes.phoneNo;
        this.generalInfo.searchStore = dataRes.storeName;
        this.generalInfo.code = dataRes.code;
        this.generalInfo.listStore = dataRes.listStore;
        this.generalInfo.department.selected = dataRes.departmentId;
      });
    },
    onSelectedStore(option) {
      this.generalInfo.searchStore = option.item.name;
      this.generalInfo.selectedStore = option.item.id;
    },
    onInputChange(text) {
      const filteredData = this.generalInfo.options
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.generalInfo.filteredOptions = [...filteredData];
    },
    setJobTitleOptions() {
      this.fetchJobTitles().then((jobTitles) => {
        this.generalInfo.position.options = jobTitles;
      });
    },
    setDepartmentOptions: async function () {
      const departments = await this.fetchDepartments();
      this.generalInfo.department.options = departments;
    },
    formatEmployeeStores(listStore) {
      return (listStore || []).map((item) => {
        return {
          ...item,
          storeId: item.id,
        };
      });
    },
  },
  validations: {
    fullName: {
      required,
      minLength: minLength(3),
    },
  },
};
</script>
